export default __webpack_public_path__ + "dfd2888ce8abfd0147cdc78129c75756.coffee";